<template>
  <div>
    <CoBrandedPageCustomer v-if="hasContractor" />
    <CoBrandedPagePartner v-if="hasPartner" />
  </div>
</template>

<script>

import CoBrandedPageCustomer from '@/views/CoBrandedPage/CoBrandedPageCustomer.vue';
import CoBrandedPagePartner from '@/views/CoBrandedPage/CoBrandedPagePartner.vue';
import { mapState } from 'vuex';

export default {
  name: 'CoBrandedPage',
  components: {
    CoBrandedPageCustomer,
    CoBrandedPagePartner,
  },
  computed: {
    ...mapState('user', {
      hasContractor: (state) => state.contractor !== null,
      hasPartner: (state) => state.partnerId !== null,
    }),
  },
};
</script>

<style lang="stylus">
@import "~@/assets/style/views/co-branded-page.styl";
</style>
